import React from 'react';
import { FileUploader } from '../shared/file-uploader';
import getLayerUploadParams from './upload-url';

interface MMPKProps {
  startUpload: boolean;
  onUploadBegin: () => void;
  onComplete: () => void;
  onError: () => void;
  maxFiles: number;
}

interface Props {
  isNew: boolean;
  fileUploaderProps: MMPKProps;
  setLayerFile: (key: string, name: string) => void;
  apiToken?: string;
}

const MMPKLayer: React.FC<Props> = ({
  isNew, fileUploaderProps, setLayerFile, apiToken,
}: Props) => {
  const getPresignedUrl = ({ file }) => getLayerUploadParams({ file, setLayerFile, apiToken });

  if (isNew) {
    return (
      <FileUploader
        {...fileUploaderProps}
        onUploadParams={getPresignedUrl}
        acceptedFileTypes=".mmpk"
        acceptedFilesName="MMPK"
      />
    );
  }

  return null;
};

export default MMPKLayer;
